import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Components/Home/Home'; // Dashboard or home screen
import Register from './Components/Home/Register'; // Dashboard or home screen
import Profile from './Components/Profile/Profile'; // Dashboard or home screen
import Editprofile from './Components/Profile/Editprofile'; // Dashboard or home screen
import Settings from './Components/Profile/Settings';
import Allprofiles from './Components/Profile/Allprofiles';
import Entryregister from './Components/Home/Entryregister';
import AboutUs from './Components/Privacydetails/Aboutus';
import Contactus from './Components/Privacydetails/Contactus';
import Login  from './Components/Login/Login';
import Forgotpasscode  from './Components/Login/ForgotPasscode';
import Profileinformation  from './Components/Profile/Profileinformation';
import About from './Components/About/About';
import PrivacyPolicy from './Components/Privacydetails/PrivacyPolicy';
import RefundPolicy from './Components/Privacydetails/RefundPolicy';
import Footer from './Components/Header/Footer';
import Addprofiledata from './Components/Home/Addprofiledata';
import User from './Components/Page/User';
import UserViewProfile from './Components/Page/User/UserViewProfile';
import Plans from './plans/Plans';
function App() {
  return (
  <Router>
      <Routes>
           <Route path="/" element={<Home />} />
             <Route path="/register" element={<Register />} />
                     <Route path="/Profile" element={<Profile />} />
                      <Route path="/editprofile" element={<Editprofile />} />
                         <Route path="settings" element={<Settings />} />
                         <Route path="/allprofiles" element={<Allprofiles />} />
                             <Route path="entryregister" element={<Entryregister />} />
                                 <Route path="AboutUs" element={<AboutUs />} />
                                         <Route path="Contactus" element={<Contactus />} />
                                             <Route path="/login" element={<Login  />} />
                                             <Route path="/Forgotpasscode" element={<Forgotpasscode  />} />
                                                         <Route path="/profileinformation" element={<Profileinformation/>} />

                             <Route path="/PrivacyPolicy" element={<PrivacyPolicy/>} />  
                              <Route path="/RefundPolicy" element={<RefundPolicy/>} />           


                               <Route path="/footer" element={<Footer/>} />    
                                <Route path="/addprofiledata" element={<Addprofiledata/>} />   
                                 <Route path="/user/dashboard" element={<User/>} />     
                                 <Route path="/user/viewprofile" element={<UserViewProfile/>} />    
                                 <Route path="/plans" element={<Plans/>} />            
                                                   
       </Routes>
    </Router>
  );
}

export default App;
